import { LoadingScreen } from "@msuite/ui/loading-screen";
import type { PropsWithChildren } from "react";
import { authClient } from "@/api/auth";

export function AuthLoading({ children }: PropsWithChildren) {
	const { isPending } = authClient.useSession();
	const LoadingScreenComponent = LoadingScreen;

	if (!isPending) {
		return null;
	}

	if (children) {
		return <>{children}</>;
	}

	return <LoadingScreenComponent />;
}
